import { useState } from 'react'

const initialState = {
  name: '',
  company: '',
  email: '',
  message: '',
}
export const Contact = (props) => {
  const [{ name, company, email, message }, setState] = useState(initialState)
  const [alert, setAlert] = useState({ type: '', message: '' })

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setAlert({ type: '', message: '' })

    const trimmedName = name.trim()
    const trimmedEmail = email.trim()
    const trimmedCompany = company.trim()
    const trimmedMessage = message.trim()

    if (!trimmedName || !trimmedCompany || !trimmedEmail || !trimmedMessage) {
      setAlert({ type: 'danger', message: 'Name, company, email, and message are required.' })
      return
    }

    // basic email format check to avoid empty/invalid payloads getting through
    const emailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
    if (!emailRegex.test(trimmedEmail)) {
      setAlert({ type: 'danger', message: 'Please enter a valid email address.' })
      return
    }

    fetch('https://email.nopsa-ventures.workers.dev/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: trimmedName, company: trimmedCompany, email: trimmedEmail, message: trimmedMessage })
    })
      .then(async (res) => {
        if (res.ok) {
          setAlert({ type: 'success', message: 'Your message has been sent successfully!' })
          setTimeout(() => {
            setAlert({ type: '', message: '' })
            setState(() => ({ ...initialState }))
          }, 5000)
        } else {
          const errorText = await res.text();
          setAlert({ type: 'danger', message: 'Failed to send message. ' + errorText })
          if (process.env.NODE_ENV === 'development') {
            console.error('Failed to send message:', errorText)
          }
        }
      })
      .catch((err) => {
        setAlert({ type: 'danger', message: 'An error occurred. Please try again later.' })
        if (process.env.NODE_ENV === 'development') {
          console.error(err)
        }
      })
  }
  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-8'>
            <div className='row'>
              <div className='section-title'>
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an message and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name='sentMessage' onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='name'
                        name='name'
                        className='form-control'
                        placeholder='Name'
                        required
                        value={name}
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='company'
                        name='company'
                        className='form-control'
                        placeholder='Company'
                        required
                        value={company}
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='email'
                        id='email'
                        name='email'
                        className='form-control'
                        placeholder='Email'
                        required
                        value={email}
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>
                <div className='form-group'>
                  <textarea
                    name='message'
                    id='message'
                    className='form-control'
                    rows='4'
                    placeholder='Message'
                    required
                    value={message}
                    onChange={handleChange}
                  ></textarea>
                  <p className='help-block text-danger'></p>
                </div>
                {alert.message && (
                  <div className={`alert alert-${alert.type} mt-3`} role="alert">
                    {alert.message}
                  </div>
                )}
                <button type='submit' className='btn btn-custom btn-lg'>
                  Send Message
                </button>
              </form>
            </div>
          </div>
          <div className='col-md-3 col-md-offset-1 contact-info'>
            <div className='contact-item'>
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className='fa fa-map-marker'></i> Address
                </span>
                {props.data ? props.data.address : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-phone'></i> Phone
                </span>{' '}
                {props.data ? props.data.phone : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-envelope-o'></i> Email
                </span>{' '}
                {props.data ? props.data.email : 'loading'}
              </p>
            </div>
          </div>
          <div className='col-md-12'>
            <div className='row'>
              <div className='social'>
                <ul>
                  <li>
                    <a href={props.data ? props.data.linkedin : '/'} target="_blank" rel="noreferrer">
                      <i className='fa fa-linkedin'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : '/'} target="_blank" rel="noreferrer">
                      <i className='fa fa-x-twitter'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : '/'} target="_blank" rel="noreferrer">
                      <i className='fa fa-youtube'></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
          &copy; 2026 Nopsa Ventures LTD
          </p>
        </div>
      </div>
    </div>
  )
}
